import http from '../services/http';

export default {
  namespaced: true,

  state: {
    pageTitle: null,
    groups: [],
    // Download & Support 底下的「群組」type slug 對照表 (與後端 PageTitleController::GROUP_TYPES 一致)
    groupTypeOptions: [
      { value: 'group-warranty-faq-rma', text: 'Warranty/FAQ/RMA' },
      { value: 'group-resources', text: 'Resources' },
      { value: 'group-marketing-tools', text: 'Marketing Tools' },
      { value: 'group-digital-marketing-materials', text: 'Digital Marketing Materials' },
      // 其實是 About Us 選單裡 Newsletter 獨立表單的副標題／圖片，借用「群組管理」畫面順便管理。
      { value: 'group-newsletter', text: 'Newsletter' },
    ],
  },

  mutations: {
    CLEAR_ALL(state) {
      state.pageTitle = null;
    },
    SET_PAGE_TITLE(state, data) {
      state.pageTitle = data;
    },
    SET_GROUPS(state, data) {
      state.groups = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    findByType({ commit }, type) {
      return http(`/page_titles/${type}`)
        .then((response) => response.body)
        .then((item) => {
          commit('SET_PAGE_TITLE', item);
        });
    },

    /* 「群組管理」列表頁: 一次取回 Download & Support 底下全部群組的標題/副標題/圖片 */
    findGroups({ commit }) {
      return http('/page_titles/groups/all')
        .then((response) => response.body)
        .then((data) => {
          commit('SET_GROUPS', data);
          return data;
        });
    },

    save(_, {
      type, ...data
    }) {
      const request = http(`/page_titles/${type}`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
  },
};
